import { render, staticRenderFns } from "./crearProyecto.vue?vue&type=template&id=c4206ee0&scoped=true"
import script from "./crearProyecto.vue?vue&type=script&lang=js"
export * from "./crearProyecto.vue?vue&type=script&lang=js"
import style0 from "./crearProyecto.vue?vue&type=style&index=0&id=c4206ee0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4206ee0",
  null
  
)

export default component.exports